import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { Testimonials } from '@/sections/Testimonials';
import React from 'react';
import { AppstoreButton, GooglePlayButton } from '@/components/buttons';
import { Testimonial } from '@/api/sanity/testimonials';
export function TestimonialsApp(t0) {
  const $ = _c(7);
  const {
    testimonials
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["testimonials", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("categories.app.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col items-center justify-center gap-2 px-4 sm:flex-row"><AppstoreButton mobileVariant="full" /><GooglePlayButton mobileVariant="full" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== testimonials) {
    t4 = <Testimonials anchorKey="testimonials.categories.app.title" title={t2} testimonials={testimonials} buttons={t3} />;
    $[4] = t2;
    $[5] = testimonials;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}